import {
  get as getUsers,
  getWithId,
  getWithExternalId,
} from 'store/queries/users';
import { compact, get } from 'lodash';

function reset() {
  return {
    app_id: null,
    app_name: null,
    users: [],
    input: '',
  };
}

const state = reset();

const actions = {
  /**
   * Get users
   *
   * @param {string}  app    An app id
   * @returns {Promise}
   */
  get({ state, commit, rootState }, { appId }) {
    return getUsers({ appId }).then(res => {
      const errors = get(res, 'data.errors');

      if (errors) {
        throw new Error(get(errors, '0.message'), 'Unable to get users');
      }

      const users = get(res, 'data.data.app.users.slice');
      commit('update', users);

      const app = get(res, 'data.data.app');
      commit('app', app);
    });
  },

  /**
   * Get user
   *
   * @param {string}  id    A user id
   * @returns {Promise}
   */
  getWithId({ state, commit, rootState }) {
    return getWithId({ id: state.input });
  },

  /**
   * Get user
   *
   * @param {string}  externalId    A user id
   * @param {string}  appId    An app id
   * @returns {Promise}
   */
  getWithExternalId({ state, commit, rootState }) {
    return getWithExternalId({
      externalId: state.input,
      appId: state.app_id,
    });
  },

  /**
   * Filter user
   *
   * @param {string}  externalId    A user id
   * @param {string}  appId    An app id
   * @returns {Promise}
   */
  async filterById({ state, commit, rootState, dispatch }) {
    commit('update', []);

    const responses = await Promise.all([
      dispatch('getWithId'),
      dispatch('getWithExternalId'),
    ]);

    const user = compact(responses.map(val => get(val, 'data.data.user')))[0];

    commit('update', user ? [user] : []);
  },
};

const mutations = {
  reset(state) {
    Object.assign(state, reset());
  },

  app(state, { id, name }) {
    Object.assign(state, { app_id: id, app_name: name });
  },

  update(state, users) {
    Object.assign(state, { users: users });
  },

  input(state, input) {
    Object.assign(state, { input: input });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
